import { withSnackbar } from 'notistack';
import React, { Component, createRef } from 'react';
import Service from '../../config/networkutils';
import MaterialTable from 'material-table';
import { AppBar, Box, Dialog, IconButton, Slide, Toolbar, Typography } from '@material-ui/core';
import moment from 'moment';
import OpenInBrowserIcon from '@material-ui/icons/OpenInBrowser';
import CloseIcon from '@material-ui/icons/Close';
import { getCookie } from '../../utils/CookieHelper'
import LeaveStatusDesktop from './LeaveStatusDesktop';

const token = getCookie("ptd_ts_token");

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class LeaveAdminAccess extends Component {
    constructor(props) {
        super(props)

        this.state = {
            data: [],
            isLoading: true,
            open: false,
            selectedData: null
        }
        this.refgetData = createRef()
        this.handleReload = this.handleReload.bind(this)
    }

    getData() {
        Service.get(`/api/ptd/employees/leave/get_leave_requests_based_on_access/`, {
            headers: {
                Authorization: "Token " + token,
            },
        }).then(res => {
            this.setState({ data: res.data, isLoading: false }, () => {
            })
        })
            .catch(error => {
                console.log(error)
                this.setState({ isLoading: false })
                if (error.status === 403) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    })
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', { variant: 'error' })
                }
            })
    }


    componentDidMount() {
        this.getData()
    }

    handleReload() {
        this.getData()
    }

    render() {

        const handleClose = () => {
            this.setState({ open: false });
        }

        return (
            <div>
                <Box margin={2}>
                    <MaterialTable
                        columns={[{
                            title: 'Employee Name', field: 'emp_first_name',
                            render: rowData => rowData.request_by_first_name + ' ' + rowData.request_by_last_name
                        }, {
                            title: 'Requested On', field: 'requested_on',
                            render: rowData => rowData.requested_on ? moment(rowData.requested_on).format('DD-MM-YYYY') : ''
                        }, {
                            title: 'Requested to', field: 'requested_to',
                            render: rowData => rowData.requested_to_first_name ? (rowData.requested_to_first_name + ' ' + rowData.requested_to_last_name) : ''
                        }, {
                            title: 'Status', field: 'approval_status',
                            lookup: { 0: 'Pending', 1: 'Approved', 2: 'Rejected', 3: 'Partially Approved', 4: "Missing" }
                        }, {
                            title: "Replied By", field: "approved_by",
                            render: rowData => rowData.approved_by ? (rowData.approved_by_first_name + ' ' + rowData.approved_by_last_name) : ''
                        }, {
                            title: 'Replied On', field: 'approved_on',
                            render: rowData => rowData.approved_on ? moment(rowData.approved_on).format('DD-MM-YYYY') : ''
                        }
                        ]}
                        data={this.state.data}
                        isLoading={this.state.isLoading}
                        title="Leave Requests"
                        options={{
                            paging: false,
                            filtering: true,
                        }}
                        actions={[{
                            icon: () => <OpenInBrowserIcon />,
                            tooltip: 'View',
                            onClick: (event, rowData) => {
                                this.setState({ selectedData: rowData }, () => {
                                    this.setState({
                                        open: true
                                    })
                                });
                            }
                        }]}
                    />
                </Box>

                <Dialog fullScreen open={this.state.open} onClose={handleClose} TransitionComponent={Transition}>
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6">
                                {this.state.selectedData?.request_by_first_name + ' ' + this.state.selectedData?.request_by_last_name + "'s Leave Request"}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                    <Box marginTop={'10px'}>
                        <LeaveStatusDesktop data={this.state.selectedData} reload={this.handleReload} mobile_view={false} />
                    </Box>
                </Dialog>
            </div>
        );
    }
}

export default withSnackbar(LeaveAdminAccess);